import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';

import { useCustomToast } from 'hooks';
import { upsertR1InvoiceInfo } from 'modules/accommodations/features/reservations/api';

export const useMutationR1InvoiceInfo = () => {
  const { t } = useTranslation();

  const queryClient = useQueryClient();

  const { successToast, errorToast } = useCustomToast();

  return useMutation(upsertR1InvoiceInfo, {
    onSuccess: () => successToast(t('R1 account details entered')),
    onError: () => errorToast(),
  });
};
